import { createBrowserLogger } from '../../../utils/createBrowserLogger.ts';

/**
 * Per abilitare i log di debug, aggiungere la chiave `FWEngineLogger_config`
 * es. `window.FWEngineLogger_config = true`
 */
export const configLogger = createBrowserLogger({
  isActive: process.env.NODE_ENV === 'development',
  debugKey: 'config',
});
